import { create } from "zustand";

export const useGapStore = create((set) => ({
    gaps: [],
    loading: false,
    error: null,
    selectedItem: null,
    columnFilters: {},
    uniqueValues: {},
    paginationData: {
        currentPage: 1,
        itemsPerPage: 10,
        totalItems: 0,
        totalPages: 0,
    },
    isFormOpen: false,
    isEditMode: false,
    isDeleteDialogOpen: false,
    itemToDelete: null,

    setLoading: (loading) => set({ loading }),
    setError: (error) => set({ error }),
    clearError: () => set({ error: null }),
    setGaps: (gaps) => set({ gaps }),
    setSelectedItem: (selectedItem) => set({ selectedItem }),
    setColumnFilters: (columnFilters) => set({ columnFilters }),
    setUniqueValues: (uniqueValues) => set({ uniqueValues }),
    setPaginationData: (data) => set((state) => ({
        paginationData: {
            ...state.paginationData,
            ...data,
            currentPage: data.page || data.currentPage || state.paginationData.currentPage,
            itemsPerPage: data.pageSize || data.itemsPerPage || state.paginationData.itemsPerPage,
            totalItems: data.total || data.totalItems || state.paginationData.totalItems,
            totalPages: data.totalPages || state.paginationData.totalPages,
        },
    })),
    openSoaEdit: (item) => set({ isFormOpen: true, isEditMode: true, selectedItem: item, error: null }),
    closeForm: () => set({ isFormOpen: false, selectedItem: null, error: null }),
}));
